import { journeyAction, settingsFormSchema } from "./base";

import { JourneyActionSendTextMessage as JourneyActionTextMessageBase } from "atlas-shared";
import { FormElementTypes } from "atlas-form";

export const JourneyActionSendTextMessage = journeyAction({
  ...JourneyActionTextMessageBase,
  settings_form: settingsFormSchema({
    elements: [{ ref: "text_message_source_id" }, { ref: "body" }],
  }),
  initialValues: {
    body: "Hello, this is a test message",
  },
  additionalParams: {
    properties_body: { ui_type: FormElementTypes.HTML, hashOptions: ["conversation", "contact"] },
  },
  icon: "Send",
});
